import React, { useState } from 'react';
import fremtidensmad from '../../images/2024.jpg';  // Import the image
import { useNavigate } from 'react-router-dom';



const stockSymbols = [
  { symbol: 'SVITZR.CO', name: 'Svitzer Group' }, // Nasdaq Copenhagen (Denmark)
  { symbol: 'CAVEN.OL', name: 'Cavendish Hydrogen' }, // Oslo Børs (Norway)
  { symbol: 'KALMAR.HE', name: 'Kalmar' }, // Nasdaq Helsinki (Finland)
  { symbol: 'SFOODS.HE', name: 'Solar Foods' }, // Nasdaq Helsinki (Finland)
  { symbol: 'RDDT', name: 'Reddit' }, // NYSE (US)
  { symbol: 'PLSV.OL', name: 'Paratus Energy Services' }, // Oslo Børs (Norway)
  { symbol: 'SVEAF.ST', name: 'Sveafastigheter' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'FLERIE.ST', name: 'Flerie' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'NNE', name: 'Nano Nuclear Energy' }, // OTC Markets (US)
  { symbol: 'APOTEA.ST', name: 'Apotea' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'ENVAR.ST', name: 'Envar' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'NEO-B.ST', name: 'Neovici Holding B' }, // Nasdaq Stockholm (Sweden)
  { symbol: '247.ST', name: '24SevenOffice Group' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'CONDO.ST', name: 'Condo Nordic' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'R3NK.DE', name: 'RENK GROUP AG INH O.N.' }, // XETRA (Germany)
  { symbol: 'EQL.ST', name: 'EQL Pharma' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'KARNEL-B.ST', name: 'Karnell' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'SERV', name: 'Serve Robotics' }, // NASDAQ (US)
  { symbol: 'PRISMA.ST', name: 'Prisma Properties' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'SASK.V', name: 'ATHA Energy Corp' }, // TSX Venture Exchange (Canada)
  { symbol: 'BRAVE.ST', name: 'Kinda Brave' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'FFSB.OL', name: 'Flekkefjord Sparebank' }, // Oslo Børs (Norway)
  { symbol: 'NREST.ST', name: 'Nordrest' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'AS', name: 'Amer Sports' }, // NYSE (US)
  { symbol: 'KSPI', name: 'Joint Stock Company Kaspi.kz' }, // NASDAQ (US)
  { symbol: 'DXYZ', name: 'Destiny Tech100' }, // NASDAQ (US)
  { symbol: 'TINGS-B.ST', name: 'Tingsvalvet Fastighets B' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'NANECH.ST', name: 'NanoEcho' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'WRV.ST', name: 'Webrock Ventures' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'SMXT', name: 'Solarmax Technology' }, // OTC Markets (US)
  { symbol: 'VIK', name: 'Viking Holdings' }, // NYSE (US)
  { symbol: 'SW', name: 'Smurfit Westrock' }, // NYSE (US)
  { symbol: 'LOT', name: 'Lotus Technology' }, // NASDAQ (US)
  { symbol: 'RBRK', name: 'Rubrik' }, // NASDAQ (US)
  { symbol: 'ZK', name: 'ZEEKR Intelligent Technology Holding' }, // NYSE (US)
  { symbol: 'TEM', name: 'Tempus AI' }, // NASDAQ (US)
  { symbol: 'ZENA', name: 'ZenaTech' }, // NASDAQ (US)
  { symbol: 'OS', name: 'Onestream' }, // NYSE (US)
]



function FintechCard18() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleCardClick = async () => {
    setLoading(true);
    setIsModalOpen(true);
    try {
      const symbolsToFetch = stockSymbols.map(stock => stock.symbol);
      console.log('Fetching symbols:', symbolsToFetch);

      const stockPromises = symbolsToFetch.map(async symbol => {
        try {
          const response = await fetch(`https://investorverden.onrender.com/api/stocks?q=${symbol}`);
          if (!response.ok) throw new Error(`Failed to fetch ${symbol}`);
          return await response.json();
        } catch (error) {
          return { error: `Symbol failed: ${symbol}` };
        }
      });

      const results = await Promise.all(stockPromises);
      console.log('Raw results:', results);

      const processedStocks = results.map(result => {
        // If there's an error property
        if (result.error) {
          return {
            logo: '',
            name: result.error,
            price: '-',
            changePercent24h: '-',
            isPositive: false,
            marketCap: '-',
            currency: '-',
          };
        }
        const { stockData: sd } = result;
        if (!sd) {
          return {
            logo: '',
            name: 'No data',
            price: '-',
            changePercent24h: '-',
            isPositive: false,
            marketCap: '-',
            currency: '-',
          };
        }
        const matchingSymbol = stockSymbols.find(s => s.symbol === sd.symbol);
        return {
          logo: sd.logo_url || '',
          name: matchingSymbol?.name || sd.shortName || sd.symbol,
          price: sd.regularMarketPrice?.toFixed(2) || '0.00',
          changePercent24h: sd.regularMarketChangePercent?.toFixed(2) || '0.00',
          isPositive: parseFloat(sd.regularMarketChangePercent) > 0,
          marketCap: sd.marketCap
            ? (sd.marketCap / 1000000000).toFixed(2) + 'B'
            : 'N/A',
          currency: sd.currency || 'USD',
        };
      });

      console.log('Processed stocks:', processedStocks);
      setStocks(processedStocks);
    } catch (error) {
      console.error('Error:', error);
      setStocks([]);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div
        className="flex flex-col col-span-full sm:col-span-6 xl:col-span-3 bg-white dark:bg-gray-800 shadow-sm rounded-xl cursor-pointer"
        onClick={handleCardClick}
      >
        <div className="px-5 pt-5">
          <header>
            <h3 className="text-sm font-semibold text-gray-500 uppercase mb-1">
              <span className="text-gray-800 dark:text-gray-100">Børsnoteringer i 2024</span>
            </h3>
          </header>
        </div>
        <div className="grow">
          <img src={fremtidensmad} alt="Fremtidens mad" className="w-full h-auto rounded-b-xl" />
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div
            className="bg-white dark:bg-gray-800 p-5 rounded-lg shadow-lg w-full max-w-4xl"
            style={{ maxHeight: '80vh', overflowY: 'auto' }}
          >
            <h2 className="text-l font-semibold mb-4">Børsnoteringer i 2024</h2>
            <p className="text-sm text-gray-700 dark:text-gray-200">
            Virksomheder, der er gået på børs (IPO) i 2024.
            <br />
            </p>
            {loading ? (
              <div className="flex justify-center items-center h-48">
                <svg
                  className="animate-spin h-10 w-10 text-violet-500"
                  xmlns="http://www.w3.org/2000/svg"  
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  ></path>
                </svg>
              </div>
            ) : (
              <table className="w-full text-left">
                <thead>
                  <tr className="border-b">
                    <th className="px-2 py-1">Logo</th>
                    <th className="px-2 py-1">Selskab</th>
                    <th className="px-2 py-1">I dag</th>
                    <th className="px-2 py-1">Børsværdi</th>
                  </tr>
                </thead>
                <tbody>
                  {stocks.map((stock, index) => (
                    <tr key={index} className="border-b">
                      <td className="px-2 py-2">
                        {stock.logo ? (
                          <img src={stock.logo} alt={stock.name} className="w-6 h-6" />
                        ) : (
                          <span>N/A</span>
                        )}
                      </td>
                      <td className="px-2 py-2">
                        {stock.name}: {stock.currency}
                      </td>
                      <td
                        className={`px-2 py-2 ${
                          stock.isPositive ? 'text-green-500' : 'text-red-500'
                        }`}
                      >
                        {stock.changePercent24h}%
                      </td>
                      <td className="px-2 py-2">{stock.marketCap}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <button
              className="mt-4 px-4 py-2 bg-violet-500 text-white rounded"
              onClick={closeModal}
            >
              Luk
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default FintechCard18;